// extracted by mini-css-extract-plugin
export default {"container":"product-section_container__ZMOjj","contentContainer":"product-section_contentContainer__xZdls"};